import "./ConfirmModal.scss";

interface ConfirmModalProps {
  isOpen: boolean;
  icon: string;
  message: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

const ConfirmModal = ({
  isOpen,
  icon,
  message,
  onConfirm,
  onCancel,
}: ConfirmModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="modalOverlay">
      <div className="modalContent">
        <span
          className={`modalIcon ${
            icon === "check" ? "icon-check" : "icon-question"
          }`}
        />
        <div className="message">{message}</div>
        <div className="modalActions">
          <button className="okButton" onClick={onConfirm}>
            OK
          </button>
          <button className="cancelButton" onClick={onCancel}>
            キャンセル
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
